export const TYPE_OLD = 0
export const TYPE_CALLS = 1
export const TYPE_MESSAGES = 2
export const TYPE_VOICEMAILS = 3
export const TYPE_RECORDINGS = 4
export const TYPE_INBOX = 6
